document.addEventListener("DOMContentLoaded", () => {
  const startBtn = document.getElementById("startBtn");
  const quizForm = document.getElementById("quizForm");
  const quizItems = quizForm.querySelectorAll(".quizItem");
  const prevBtn = quizForm.querySelector("[data-btn='prev']");
  const nextBtn = quizForm.querySelector("[data-btn='next']");
  const finishBtn = quizForm.querySelector("button[type='submit']");
  const genderInputs = quizForm.querySelectorAll("input[name='gender']");
  const issueOptionsContainer = document.getElementById("issue_otions");
    // Make productData globally accessible
  window.productData = [];
  const CONSULTATION_PRODUCTS = [
    { handle: 'starter-consultation-basic', title: 'Starter Consultation (Basic)' },
    { handle: 'advanced-consultation-comprehensive', title: 'Advanced Consultation (Comprehensive)' }
  ];

  let currentStep = 0;
  let selectedGender = null;
  let selectedIssue = null;
  let activeQuestions = [];
  let currentQuestionIndex = 0;

  // Track all answers with score
  let answers = {}; // { questionId: { answerId, score } }

  resetQuiz();

  // ===== Start Quiz =====
  startBtn.addEventListener("click", () => {
    document.querySelector(".startContainer").style.display = "none";
    showStep(0);
    nextBtn.style.display = "inline-block";
  });

  // ===== Gender Selection =====
  genderInputs.forEach(input => {
    input.addEventListener("change", (e) => {
      selectedGender = e.target.value.toLowerCase();
      populateIssues(selectedGender);
    });
  });

  // ===== Issue Selection =====
  issueOptionsContainer.addEventListener("change", (e) => {
    selectedIssue = e.target.value;
    if (!selectedIssue) return;

    filterQuestions();
    currentQuestionIndex = 0;

    // Show correct gender wrapper
    document.querySelector(".men_quiz_quetions").classList.remove("active");
    document.querySelector(".women_quiz_quetions").classList.remove("active");
    if (selectedGender === "men") {
      document.querySelector(".men_quiz_quetions").classList.add("active");
    } else {
      document.querySelector(".women_quiz_quetions").classList.add("active");
    }

    quizItems[2].style.display = "none";
    showActiveQuestion();
  });

  // ===== Next Button =====
  nextBtn.addEventListener("click", () => {
    if (!validateCurrent()) return;

    if (currentStep >= 3 && activeQuestions.length) {
      goToNextQuestion();
    } else {
      if (currentStep < quizItems.length - 1) {
        showStep(currentStep + 1);
      }
    }
  });

  // ===== Previous Button =====
  prevBtn.addEventListener("click", () => {
    if (currentStep >= 3 && activeQuestions.length) {
      if (currentQuestionIndex > 0) {
        currentQuestionIndex--;
        showActiveQuestion();
        return;
      }
    }
    if (currentStep > 0) {
      showStep(currentStep - 1);
    }
  });

// ===== Track answers + auto-next (single listener) =====
quizForm.addEventListener("change", (e) => {
  const input = e.target;

  if (!input.classList.contains("quiz_radio_input")) return;

  // ---- Store / update answer ----
  if (input.dataset.score) {
    const questionEl = input.closest(".quizItem");
    if (questionEl) {
      const questionId = questionEl.dataset.questionId;
      answers[questionId] = {
        answerId: input.value,
        score: parseFloat(input.dataset.score || "0")
      };
    }
  }

  // ---- Auto move to next ----
  setTimeout(() => {
    if (!nextBtn || nextBtn.style.display === "none") return;

    // Intro steps (name / gender / issue)
    if (currentStep < 3) {
      nextBtn.click();
      return;
    }

    // Question steps
    if (validateCurrent()) {
      nextBtn.click();
    }
  }, 200);
});

quizForm.addEventListener('keydown', (e) => {
  // If Enter is pressed and the target is not a textarea, block it
  if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA') {
    e.preventDefault();
    nextBtn.click();
  }
});


  // ===== Submit Quiz =====
  quizForm.addEventListener("submit", (e) => {
    e.preventDefault();
    if (!validateCurrent()) return;

    const finalAnswers = {};
    for (let qId in answers) {
      finalAnswers[qId] = answers[qId].answerId;
    }
    // console.log(Object.keys(finalAnswers))

    const totalScore = calculateTotalScore();
    const customerName = document.getElementById("custom_customer_name")?.value || "";
    const gender = selectedGender;
    const issueId = selectedIssue;

    const issueLabel = issueOptionsContainer.querySelector(`input[value="${issueId}"] + label`);
    const issueTitle = issueLabel ? issueLabel.textContent.trim() : "";

    const matchedStage = quizSchema.stageDefination.find(stage => {
      return (
        stage.issueId === issueId &&
        totalScore >= stage.minScore &&
        totalScore <= stage.maxScore
      );
    });

    const formData = {
      name: customerName,
      gender: gender,
      issue_id: issueId,
      issue_title: issueTitle,
      answers: finalAnswers,
      totalScore: totalScore,
      stage: matchedStage ? matchedStage.stage : null,
      stageTitle: matchedStage ? matchedStage.stageTitle : null,
      products: matchedStage ? matchedStage.products : [],
      stageData: matchedStage || null
    };
    console.log("✅ Final Form Data:", formData);
    
    showResult(formData);
    updateProgress(true);
    emailBodyFormatter(formData);
    localStorage.setItem("JSON_DATA_SET_ASSEMENT", JSON.stringify(formData));
  });

  // ===== Helpers =====
  const progressBar = document.getElementById("quizProgressBar");

  function updateProgress(isFinalSubmit = false) {
    const introSteps = 3;
    const totalQuestions = activeQuestions.length;
    const introWeight = 30;
    const questionWeight = 70;
    let progressPercent = 0;

    if (currentStep < introSteps) {
      progressPercent = ((currentStep + 1) / introSteps) * introWeight;
    } else {
      const questionIndex = currentQuestionIndex;
      progressPercent = introWeight + (questionIndex / totalQuestions) * questionWeight;
      if (isFinalSubmit) progressPercent = 100;
    }
    progressBar.style.width = Math.min(progressPercent, 100) + "%";
  }

  function resetQuiz() {
    quizItems.forEach(item => {
      item.style.display = "none";
      toggleRequired(item, false);
    });
    prevBtn.style.display = "none";
    nextBtn.style.display = "none";
    finishBtn.style.display = "none";
  }

  function showStep(index) {
    quizItems.forEach((item, i) => {
      item.style.display = "none";
      toggleRequired(item, false);
    });
    quizItems[index].style.display = "flex";
    toggleRequired(quizItems[index], true);
    currentStep = index;

    prevBtn.style.display = index === 0 ? "none" : "inline-block";
    finishBtn.style.display = "none";
    nextBtn.style.display = "inline-block";

    updateProgress();
  }

  function showActiveQuestion() {
    quizItems.forEach(item => {
      item.style.display = "none";
      toggleRequired(item, false);
    });

    const q = activeQuestions[currentQuestionIndex];
    if (!q) return;

    q.style.display = "flex";
    toggleRequired(q, true);
    currentStep = 3;

    prevBtn.style.display = "inline-block";

    const isLast = (!q.dataset.hasNext || q.dataset.hasNext === "" || q.dataset.hasNext === "null");
    if (currentQuestionIndex === activeQuestions.length - 1 && isLast) {
      nextBtn.style.display = "none";
      finishBtn.style.display = "inline-block";
    } else {
      nextBtn.style.display = "inline-block";
      finishBtn.style.display = "none";
    }

    updateProgress();
  }

  function goToNextQuestion() {
    const currentQ = activeQuestions[currentQuestionIndex];
    const nextId = currentQ.dataset.hasNext;

    if (nextId && nextId !== "null" && nextId !== "") {
      const nextQ = activeQuestions.find(q => q.dataset.questionId === nextId);
      if (nextQ) {
        currentQuestionIndex = activeQuestions.indexOf(nextQ);
        showActiveQuestion();
        return;
      }
    }
    if (currentQuestionIndex < activeQuestions.length - 1) {
      currentQuestionIndex++;
      showActiveQuestion();
    } else {
      finishBtn.style.display = "inline-block";
      nextBtn.style.display = "none";
    }
  }

  function populateIssues(gender) {
    const issues = quizSchema.gender_based_conditions[gender] || [];
    issueOptionsContainer.innerHTML = "";
    issues.forEach(issue => {
      const inputId = `issue_${issue.id}`;
      const wrapper = document.createElement("div");
      wrapper.classList.add("option_wrapper");
      wrapper.innerHTML = `
        <input 
          type="radio" 
          id="${inputId}" 
          name="issue" 
          value="${issue.id}" 
          class="quiz_radio_input"
          required
        >
        <label class="quiz_option_label" for="${inputId}">${issue.condition}</label>
      `;
      issueOptionsContainer.appendChild(wrapper);
    });
  }

  function filterQuestions() {
    if (selectedGender === "men") {
      activeQuestions = [...document.querySelectorAll(
        `.men_quiz_quetions .quizItem[data-issue-category-id="${selectedIssue}"]`
      )];
    } else {
      activeQuestions = [...document.querySelectorAll(
        `.women_quiz_quetions .quizItem[data-issue-category-id="${selectedIssue}"]`
      )];
    }
    activeQuestions.sort((a, b) => {
      const idA = a.dataset.questionId;
      const idB = b.dataset.questionId;
      const numA = parseInt(idA.match(/\d+$/)?.[0] || "0", 10);
      const numB = parseInt(idB.match(/\d+$/)?.[0] || "0", 10);
      return numA - numB;
    });
  }

  function validateCurrent() {
    const currentItem = (currentStep >= 3 && activeQuestions.length)
      ? activeQuestions[currentQuestionIndex]
      : quizItems[currentStep];
    if (!currentItem) return true;

    const warningEl = currentItem.querySelector(".quiz_warning");
    if (warningEl) warningEl.style.display = "none";

    const inputs = currentItem.querySelectorAll("input[required]");
    for (let input of inputs) {
      if (
        (input.type === "radio" || input.type === "checkbox") &&
        !currentItem.querySelector(`input[name="${input.name}"]:checked`)
      ) {
        if (warningEl) {
          warningEl.textContent = "⚠ Please select an option before continuing.";
          warningEl.style.display = "block";
        }
        return false;
      }
      if (input.type === "text" && !input.value.trim()) {
        if (warningEl) {
          warningEl.textContent = "⚠ Please fill out this field.";
          warningEl.style.display = "block";
        }
        return false;
      }
    }
    return true;
  }

  function calculateTotalScore() {
    let total = 0;
    for (let key in answers) {
      total += answers[key].score || 0;
    }
    return total;
  }

  // ====== NEW: fetch product by handle ======
  async function fetchProduct(handle) {
    const res = await fetch(`/products/${handle}.js`);
    if (!res.ok) throw new Error(`Failed to fetch ${handle}`);
    return res.json();
  }

async function fetchConsultationProduct(handle) {
  try {
    const res = await fetch(`/products/${handle}.js`);
    if (!res.ok) throw new Error(`Failed to fetch ${handle}`);
    return await res.json();
  } catch (error) {
    console.error(`Error fetching consultation product ${handle}:`, error);
    return null;
  }
}

async function addConsultationToBundle(consultationProduct, productData, cardsRow) {
  // Ensure consultation product has proper price structure
  if (!consultationProduct.price) {
    console.warn('Consultation product missing price:', consultationProduct);
    return;
  }
  
  // Add to beginning of productData array (top of list)
  productData.unshift({
    ...consultationProduct,
    quantity: 1,
    selectedPrice: consultationProduct.price || consultationProduct.variants?.[0]?.price || 0,
    isConsultation: true,
    consultationHandle: consultationProduct.handle
  });

  // Create product item HTML (same as before)
  const item = document.createElement('div');
  item.classList.add('product_item');
  item.dataset.consultation = true;
  
  const card = document.createElement('div');
  card.classList.add('product_link');
  
  const productUrl = `/products/${consultationProduct.handle}`;
  card.innerHTML = `
    <div class="product_left">
      <a href="${productUrl}" target="_blank" class="product_media_link">
        <img src="${consultationProduct.featured_image || consultationProduct.featuredImage}" alt="${consultationProduct.title}" class="product_img">
      </a>
      <div class="product_info">
        <a href="${productUrl}" target="_blank" class="product_title_link">
          <h4 class="product_title">${consultationProduct.title}</h4>
        </a>
        <p class="product_subtitle">Consultation Service</p>
        <p class="product_price">
          ${typeof Shopify !== 'undefined' && Shopify.formatMoney ? 
            Shopify.formatMoney(consultationProduct.price) : 
            `₹${(consultationProduct.price / 100).toFixed(2)}`}
        </p>
        <div class="product_quantity">
          <span>Quantity: </span> <span>1</span>
        </div>
        <button type="button" class="remove-consultation" data-handle="${consultationProduct.handle}" 
                style="margin-top: 8px; padding: 4px 8px; font-size: 12px; background: #ff4444; color: white; border: none; border-radius: 4px; cursor: pointer;">
          Remove
        </button>
      </div>
    </div>
  `;
  
  item.appendChild(card);
  cardsRow.insertBefore(item, cardsRow.firstChild); // Add to top in DESKTOP

  // Also add to MOBILE cloned bundle (if present)
  const mobileWrapper = document.querySelector(
    ".mobile_bundle_window_wrpper .quiz_products"
  );
  if (mobileWrapper) {
    const mobileItem = item.cloneNode(true);
    mobileWrapper.insertBefore(mobileItem, mobileWrapper.firstChild);
    // Rebind remove listeners for mobile copy as well
    bindConsultationRemoveListeners(mobileWrapper);
  }

  // Rebind remove listeners on desktop
  bindConsultationRemoveListeners(cardsRow);

  // Update subtotal for both
  updateBundleSubtotal();

  console.log(
    "Consultation product added - productData length:",
    (window.productData || []).length
  );
}



function bindConsultationRemoveListeners(cardsRow) {
  cardsRow.querySelectorAll('.remove-consultation').forEach(btn => {
    // Remove existing listeners to prevent duplicates
    btn.replaceWith(btn.cloneNode(true));
    const newBtn = cardsRow.querySelector(`[data-handle="${btn.dataset.handle}"]`);
    
    newBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      const handle = e.target.dataset.handle;
      
      // Remove from productData
      const index = window.productData.findIndex(p => p.consultationHandle === handle);
      if (index > -1) {
        window.productData.splice(index, 1);
        console.log('Removed consultation from productData, new length:', window.productData.length);
      }
      
      // Remove DOM element
      e.target.closest('.product_item').remove();
      
      // CRITICAL: Update ALL subtotals
      updateBundleSubtotal();
    });
  });
}


  // ====== NEW: add bundle to cart ======
  // function addBundleToCart(selectedVariants) {
  //   const items = selectedVariants.map(v => ({
  //     id: Number(v.id),
  //     quantity: 1
  //   }));

  //   fetch("/cart/add.js", {
  //     method: "POST",
  //     headers: { "Content-Type": "application/json" },
  //     body: JSON.stringify({ items })
  //   })
  //     .then(res => res.json())
  //     .then(() => {
  //       console.log("Bundle added with variant selections!");

  //       fetch("/cart.js")
  //         .then(res => res.json())
  //         .then(cart => {
  //           updateCartCount(cart.item_count);

  //           if (window.T4S?.loadCart) {
  //             window.T4S.loadCart();
  //           } else if (window.t4s_cart?.getCartAjax) {
  //             window.t4s_cart.getCartAjax();
  //           }

  //           const cartBtn = document.querySelector(
  //             '.t4s-site-nav__cart a[data-drawer-options*="t4s-mini_cart"]'
  //           );
  //           if (cartBtn) setTimeout(() => cartBtn.click(), 400);
  //         });
  //     })
  //     .catch(err => console.error("Error adding bundle:", err));
  // }

function buyNowBundle(selectedVariants, buttonEl) {
  const source = window.productData || [];

  const items = selectedVariants.map(v => {
    const prod = source[v.productIndex];
    const qty = prod && prod.quantity ? prod.quantity : 1;

    return {
      id: Number(v.id),
      quantity: qty,
    };
  });

  console.log('BuyNow items', items, 'productData:', source, 'selectedVariants:', selectedVariants);

  fetch('/cart/clear.js', { method: 'POST' })
    .then(() =>
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),   // wrap in { items }
      })
    )
    .then(res => res.json())
    .then(data => {
      console.log('Cart add response:', data);
      window.location.href = '/cart';
    })
    .catch(err => {
      console.error('BuyNow error', err);
      buttonEl.classList.remove('loading');
      alert('Something went wrong.');
    });
}



// 🔁 Update the cart icon badge
function updateCartCount(countValue = null) {
  const update = count => {
    const countEls = document.querySelectorAll(
      "[data-cart-count], .t4s-cart-count, .cart-count"
    );
    countEls.forEach(el => {
      el.textContent = count;
      el.classList.toggle("t4s-op-0", count === 0);
    });
    console.log("Cart count updated:", count);
  };

  if (countValue !== null) {
    update(countValue);
  } else {
    fetch("/cart.js")
      .then(res => res.json())
      .then(cart => update(cart.item_count))
      .catch(err => console.error("Error fetching cart:", err));
  }
}


function updateBundleSubtotal() {
  let total = 0;
  
  // Use global productData
  window.productData.forEach(prod => {
    const price = prod.selectedPrice || prod.price || 0;
    const quantity = prod.quantity || 1;
    total += (price / 100) * quantity;
  });
  
  console.log('Subtotal calculation - total:', total, 'productData length:', window.productData.length);
  
  // Update ALL subtotal elements (desktop + mobile)
  const allSubtotalEls = document.querySelectorAll('#bundleSubtotal');
  allSubtotalEls.forEach(subtotalEl => {
    if (subtotalEl) {
      const formattedPrice = typeof Shopify !== 'undefined' && Shopify.formatMoney 
        ? Shopify.formatMoney(total * 100) 
        : `₹${total.toFixed(2)}`;
      subtotalEl.innerHTML = formattedPrice;
    }
  });
  
  // Also update mobile bundle subtotal if it exists
  const mobileSubtotals = document.querySelectorAll('.quiz_bundle_subtotal #bundleSubtotal');
  mobileSubtotals.forEach(subtotalEl => {
    if (subtotalEl) {
      const formattedPrice = typeof Shopify !== 'undefined' && Shopify.formatMoney 
        ? Shopify.formatMoney(total * 100) 
        : `₹${total.toFixed(2)}`;
      subtotalEl.innerHTML = formattedPrice;
    }
  });
}


// showResult({
//     "name": "John",
//     "gender": "men",
//     "issue_id": "M001",
//     "issue_title": "Premature ejaculation",
//     "answers": {
//         "M1Q1": "25-34",
//         "M1Q2": "1-2 mins",
//         "M1Q3": "Often",
//         "M1Q4": "Yes ,Sometime",
//         "M1Q5": "Regular",
//         "M1Q6": "Sometimes",
//         "M1Q7": "Yes, home remedies",
//         "M1Q8": "Majorly affected"
//     },
//     "totalScore": 16,
//     "stage": 4,
//     "stageTitle": "Severe PE (high partner impact, product + medical needed)",
//     "products": [
//         {
//             "id": null,
//             "handle": null,
//             "title": null,
//             "quantity": 3
//         },
//         {
//             "id": null,
//             "handle": "men-s-libido-booster-effervescent-tablets",
//             "title": "My Soul Delay Climax Tablets for Men – Orange Flavoured Effervescent Supplement",
//             "quantity": 5
//         },
//         {
//             "id": null,
//             "handle": "ejacudelay-delay-spray-for-men",
//             "title": "EjacuDelay – Long Last Delay Spray for Men",
//             "quantity": 2
//         }
//     ],
//     "stageData": {
//         "gender": "Male",
//         "issueId": "M001",
//         "stage": 4,
//         "stageTitle": "Severe PE (high partner impact, product + medical needed)",
//         "minScore": 14,
//         "maxScore": 18,
//         "products": [
//             {
//                 "id": null,
//                 "handle": null,
//                 "title": null,
//                 "quantity": 3
//             },
//             {
//                 "id": null,
//                 "handle": "men-s-libido-booster-effervescent-tablets",
//                 "title": "My Soul Delay Climax Tablets for Men – Orange Flavoured Effervescent Supplement",
//                 "quantity": 5
//             },
//             {
//                 "id": null,
//                 "handle": "ejacudelay-delay-spray-for-men",
//                 "title": "EjacuDelay – Long Last Delay Spray for Men",
//                 "quantity": 2
//             }
//         ],
//         "monthStageBarImage": "//m3qpj41g3ejtwapp-87071129886.shopifypreview.com/cdn/shop/files/my_soul_stage_bar.png?v=1766392134",
//         "monthStageBarImageMobile": "//m3qpj41g3ejtwapp-87071129886.shopifypreview.com/cdn/shop/files/Artboard_1_copy.png?v=1766468179",
//         "resultTimelineBanner": "//m3qpj41g3ejtwapp-87071129886.shopifypreview.com/cdn/shop/files/premature_ejaculation_result_timeline.png?v=1766487312",
//         "resultTimelineBannerMobile": "//m3qpj41g3ejtwapp-87071129886.shopifypreview.com/cdn/shop/files/premature_ejaculation_result_timeline_mobile.png?v=1766487313",
//         "issueCausesImage": "//m3qpj41g3ejtwapp-87071129886.shopifypreview.com/cdn/shop/files/premature_ejaculation.png?v=1766487311",
//         "issueCausesImageMobile": "//m3qpj41g3ejtwapp-87071129886.shopifypreview.com/cdn/shop/files/premature_ejaculation_mobile.png?v=1766487311",
//         "stageTestimonials": [
//             {
//                 "name": "Rohan",
//                 "age": "28",
//                 "review": "I used to finish within a minute. By the 2nd month, I could last long enough to satisfy my partner."
//             },
//             {
//                 "name": "Ankit",
//                 "age": "30",
//                 "review": "Delay spray gave me immediate control, but lifestyle tips made it permanent over 3 months."
//             },
//             {
//                 "name": "Suresh",
//                 "age": "34",
//                 "review": "Earlier, I avoided intimacy. Now, I feel confident and connected again."
//             },
//             {
//                 "name": "Karthik",
//                 "age": "26",
//                 "review": "With guidance, I doubled my duration in 8 weeks."
//             },
//             {
//                 "name": "Varun",
//                 "age": "32",
//                 "review": "The combination of therapy + spray worked wonders for my married life."
//             },
//             {
//                 "name": "Deepak",
//                 "age": "29",
//                 "review": "Within 3 months, my PE problem was under control, and anxiety disappeared."
//             }
//         ],
//         "stageFaqs": [
//             {
//                 "question": "Can PE be cured?",
//                 "answer": "Yes, with sprays, medication, and behavior therapy, most men see results in 2–3 months."
//             },
//             {
//                 "question": " Is it harmful to ejaculate frequently?",
//                 "answer": "Regular ejaculation is healthy, but excessive frequency may cause sensitivity issues."
//             }
//         ]
//     }
// });

function showResult(data) {
  quizForm.style.display = "none";
  const resultBox = document.createElement("div");
  resultBox.classList.add("quiz_result");



  if (data.stage) {
    resultBox.innerHTML = `
      <div class="result_box_content_wrap">
        <h2>Your Sexual Health Report is Ready 🎯</h2>
        <p class="quiz_cusstomer_name">${data.name || ""}</p>
        <p class="stage_label_text">You are currently on:</p>
        <h3 class="stage_title">
          Stage ${data.stage}: ${data.stageTitle || ""}
        </h3>
        <p>
          Issue: <strong>${data.issue_title || ""}</strong>
        </p>
        <p>Thank you, ${data.name || ""}, for completing the quiz!</p>

        <!-- ⭐ STAGE BAR BANNER -->
        ${
          data.stageData?.monthStageBarImage ||
          data.stageData?.monthStageBarImageMobile
            ? `
            <div class="stage_bar_banner">
              ${
                data.stageData?.monthStageBarImage
                  ? `<img class="desktop_image"
                         src="${data.stageData.monthStageBarImage}"
                         alt="Stage progress" />`
                  : ""
              }
              ${
                data.stageData?.monthStageBarImageMobile
                  ? `<img class="mobile_image"
                         src="${data.stageData.monthStageBarImageMobile}"
                         alt="Stage progress mobile" />`
                  : ""
              }
            </div>
            `
            : ""
        }

        <!-- ⭐ TESTIMONIAL SLIDER -->
        ${
          data.stageData?.stageTestimonials?.length
            ? `
            <div class="testimonial_section">
              <div class="testimonial_header_row">
                <h4 class="testimonial_heading">What others experienced</h4>
              </div>
              <div class="testimonial_slider">
                <div class="testimonial_track">
                  ${data.stageData.stageTestimonials
                    .map(t => `
                      <div class="testimonial_card">
                        <p class="testimonial_review">"${t.review || ""}"</p>
                        <p class="testimonial_author">
                          ${t.name || ""}
                          ${
                            t.age
                              ? `<br><span style="font-weight:400;font-size:16px;">
                                  Age: ${t.age}
                                 </span>`
                              : ""
                          }
                        </p>
                      </div>
                    `)
                    .join("")}
                </div>
              </div>
              <div class="testimonial_controls">
                <button type="button" class="testimonial_prev" aria-label="Previous testimonial">‹</button>
                <button type="button" class="testimonial_next" aria-label="Next testimonial">›</button>
              </div>
            </div>
            `
            : ""
        }

        <!-- ⭐ FAQ ACCORDION -->
        ${
          data.stageData?.stageFaqs?.length
            ? `
            <div class="faq_section">
              <h4 class="faq_heading">Frequently Asked Questions</h4>
              <div class="faq_accordion">
                ${data.stageData.stageFaqs
                  .map((faq, idx) => `
                    <div class="faq_item${idx === 0 ? " faq_item--active" : ""}">
                      <button type="button" class="faq_question_btn">
                        <span>${faq.question || ""}</span>
                        <span class="faq_icon">${idx === 0 ? "−" : "+"}</span>
                      </button>
                      <div class="faq_answer"
                           ${idx === 0 ? 'style="max-height:500px;"' : ""}>
                        <p>${faq.answer || ""}</p>
                      </div>
                    </div>
                  `)
                  .join("")}
              </div>
            </div>
            `
            : ""
        }

        <!-- ⭐ RESULT TIMELINE & CAUSES -->
        ${
          data.stageData?.resultTimelineBanner ||
          data.stageData?.resultTimelineBannerMobile ||
          data.stageData?.issueCausesImage ||
          data.stageData?.issueCausesImageMobile
            ? `
            <div class="result_timeline_image_wrap">
              ${
                data.stageData?.resultTimelineBanner
                  ? `<img class="desktop_image"
                         src="${data.stageData.resultTimelineBanner}"
                         alt="Stage timeline progress" />`
                  : ""
              }
              ${
                data.stageData?.resultTimelineBannerMobile
                  ? `<img class="mobile_image"
                         src="${data.stageData.resultTimelineBannerMobile}"
                         alt="Stage timeline progress mobile" />`
                  : ""
              }
              ${
                data.stageData?.issueCausesImage
                  ? `<img class="desktop_image"
                         src="${data.stageData.issueCausesImage}"
                         alt="Causes of the issue" />`
                  : ""
              }
              ${
                data.stageData?.issueCausesImageMobile
                  ? `<img class="mobile_image"
                         src="${data.stageData.issueCausesImageMobile}"
                         alt="Causes of the issue mobile" />`
                  : ""
              }
            </div>
            `
            : ""
        }

        <!-- ⭐ CONSULTATION PRODUCTS SECTION -->
        <div class="consultation-products-section" style="display: none;">
          <div class="consultation-header">
            <h4 style="margin: 0 0 20px 0; color: #473074; font-size: 20px;">Add Expert Consultation</h4>
            <p style="color: #666; margin-bottom: 20px;">Get personalized guidance from our experts</p>
          </div>
          <div class="consultation-grid">
            <!-- Products will be populated here -->
          </div>
        </div>
      </div>
    `;
  } else {
    resultBox.innerHTML = `
      <div class="result_box_content_wrap">
        <h2>Your Total Score: ${data.totalScore}</h2>
        <p>Sorry, we couldn't match your stage. Please try again.</p>
        <!-- Consultation section will be added here too -->
        <div class="consultation-products-section" style="display: none;">
          <div class="consultation-header">
            <h4 style="margin: 0 0 20px 0; color: #473074; font-size: 20px;">Add Expert Consultation</h4>
            <p style="color: #666; margin-bottom: 20px;">Get personalized guidance from our experts</p>
          </div>
          <div class="consultation-grid">
            <!-- Products will be populated here -->
          </div>
        </div>
      </div>
    `;
  }

  // Append resultBox to DOM first
  quizForm.parentElement.appendChild(resultBox);

  // Initialize testimonial and FAQ sliders
  initTestimonialSlider(resultBox);
  initFaqAccordion(resultBox);

  // === PRODUCT BUNDLE SECTION ===
  if (data.products && data.products.length) {
    console.log("Products found for stage:", data.products);

    const productWrapper = document.createElement("div");
    productWrapper.classList.add("quiz_products_wrapper");

    const cardsRow = document.createElement("div");
    cardsRow.classList.add("quiz_products");

    const bundleHeader = document.createElement("div");
    bundleHeader.classList.add("bundle_header");
    bundleHeader.innerHTML = `
      <h4 class="bundle_title">Personalised Treatment Kit</h4>
      <button type="button" class="bundle_toggle_btn" aria-label="Minimize bundle">−</button>
    `;

    const validSourceProducts = data.products.filter(p => {
      if (!p || !p.handle || !p.title) {
        console.warn("Skipping product with missing handle/title in stage data:", p);
        return false;
      }
      return true;
    });

    if (!validSourceProducts.length) {
      console.warn("No valid products after filtering stage data.");
    } else {
      Promise.all(validSourceProducts.map(p => fetchProduct(p.handle)))
        .then(products => {
          console.log("Fetched product JSON:", products);

          let bundleSubtotal = 0;

            products.forEach((prod, index) => {
              const quizProduct = validSourceProducts[index];

              if (!prod || !prod.variants || !prod.variants.length) {
                console.warn("Skipping invalid fetched product for handle:", quizProduct.handle, prod);
                return;
              }

              // ✅ FIXED: Find cheapest variant FIRST
              const cheapestVariant = prod.variants.reduce((cheapest, current) => 
                current.price < cheapest.price ? current : cheapest
              );

              // ✅ FIXED: Use cheapest variant price & track ID
              const mergedProduct = {
                ...prod,
                quantity: quizProduct.quantity || 1,
                selectedPrice: cheapestVariant.price,  // ✅ FIXED
                selectedVariantId: cheapestVariant.id   // ✅ TRACK VARIANT
              };

              window.productData.push(mergedProduct);

              const linePrice = (cheapestVariant.price / 100) * mergedProduct.quantity;
              bundleSubtotal += linePrice;

              const item = document.createElement("div");
              item.classList.add("product_item");

              const card = document.createElement("div");
              card.classList.add("product_link");

              const productUrl = prod.url || `/products/${prod.handle}`;

              let variantSelectorHTML = '';
              if (prod.variants && prod.variants.length > 1) {
                variantSelectorHTML = `<select id="bundleProduct_variantSelector" class="variant_selector" data-index="${index}">
                  ${prod.variants.map(v => `
                    <option value="${v.id}" data-price="${v.price}" 
                            ${v.id === cheapestVariant.id ? 'selected' : ''}>
                      ${v.title} - ${typeof Shopify !== 'undefined' && Shopify.formatMoney 
                        ? Shopify.formatMoney(v.price) 
                        : `₹${(v.price / 100).toFixed(2)}`}
                    </option>
                  `).join('')}
                </select>`;
              }

              // ✅ FIXED: Show CHEAPEST variant price
              card.innerHTML = `
                <div class="product_left">
                  <a href="${productUrl}" target="_blank" class="product_media_link">
                    <img src="${prod.featured_image || prod.featuredImage}" alt="${prod.title}" class="product_img"/>
                  </a>
                  <div class="product_info">
                    <a href="${productUrl}" target="_blank" class="product_title_link">
                      <h4 class="product_title">${prod.title}</h4>
                    </a>
                    <p class="product_subtitle">${prod.subtitle || ""}</p>
                    <p class="product_price">
                      ${typeof Shopify !== 'undefined' && Shopify.formatMoney 
                        ? Shopify.formatMoney(cheapestVariant.price)  // ✅ FIXED
                        : `₹${(cheapestVariant.price / 100).toFixed(2)}`}
                    </p>
                    ${variantSelectorHTML}
                    <div class="product_quantity">
                      <span>Quantity: </span>${mergedProduct.quantity}
                    </div>
                  </div>
                </div>
              `;

              item.appendChild(card);
              cardsRow.appendChild(item);
            });


          const bundleBox = document.createElement("div");
          bundleBox.classList.add("quiz_bundle_btn_box");

          const subtotalBox = document.createElement("div");
          subtotalBox.classList.add("quiz_bundle_subtotal");
          subtotalBox.innerHTML = `
            <div class="subtotal_row">
              <span class="bundle_text">Bundle Price</span>
              <strong id="bundleSubtotal">
                ${
                  typeof Shopify !== "undefined" && Shopify.formatMoney
                    ? Shopify.formatMoney(bundleSubtotal * 100)
                    : `₹${bundleSubtotal.toFixed(2)}`
                }
              </strong>
            </div>
          `;

          const bundleBtn = document.createElement("button");
          bundleBtn.innerHTML = `
            <span class="btn-text">Buy Recommended Bundle</span>
            <span class="btn-loader">
              <span class="spinner"></span>
            </span>
          `;
          let popupSeen = false;


          function generatePDF(){
            const userDataPDF = JSON.parse(localStorage.getItem("JSON_DATA_SET_ASSEMENT"));
            const dateOfCreation = new Date(); 
            const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
            let pdfhtmlcontent = `<main style="width: 100%;margin: auto; border-top: 5px solid #503f8b;padding: 0px 10px 20px">
    <div style="width: 100%;text-align: center;display: flex;align-items: center;justify-content: space-between;padding: 10px 0;">
        <div>
            <img src="https://cdn.shopify.com/s/files/1/0870/7112/9886/files/My_Soul_new_logo.png?v=1740119549&width=100" width="80px">
        </div>
        <span style="color: #503f8b;">
            <b>DATE: </b>
            <span class="date" style="border-bottom: 1px solid #503f8b;padding-bottom: 2px;">${months[dateOfCreation.getMonth()]} ${dateOfCreation.getDate()}, ${dateOfCreation.getFullYear()}</span>
        </span>
    </div>
    <div style="width: 100%; margin: 20px auto; border-radius: 10px;overflow: hidden;background-color: #efefef;">
        <div style="background: #503f8b; padding: 10px;color: white;font-weight: 600;">About You</div>
        <div style="display: flex;flex-wrap: wrap;padding: 10px;">
            <div style="width: 50%;margin: 10px 0;">
                <div style="color: #503f8b;"><b>Name:</b> <span style="border-bottom: 1px solid #503f8b;padding-bottom: 2px;">${userDataPDF.name}</span></div>
            </div>
            <div style="width: 50%;margin: 10px 0;">
                <div style="color: #503f8b;"><b>Age:</b> <span style="border-bottom: 1px solid #503f8b;padding-bottom: 2px;">${Object.values(userDataPDF.answers)[0]}</span></div>
            </div>
            <div style="width: 50%;margin: 10px 0;">
                <div style="color: #503f8b;"><b>Concern Discussed:</b> <span style="border-bottom: 1px solid #503f8b;padding-bottom: 2px;">${userDataPDF.issue_title}</span></div>
            </div>
        </div>
    </div>
    <div style="width: 100%; margin: 20px auto; border-radius: 10px;overflow: hidden;background-color: #efefef;">
        <div style="background: #503f8b; padding: 10px;color: white;font-weight: 600;">Stage</div>
        <div style="display: flex;flex-wrap: wrap;padding: 10px;">
            <div style="width: 100%;margin: 10px 0;">
                <div style="color: #503f8b;"><b>Stage & Type of issue:</b> <span style="border-bottom: 1px solid #503f8b;padding-bottom: 2px;">${userDataPDF.stage} & ${userDataPDF.stageTitle}</span></div>
            </div>
        </div>
    </div>
    <div style="width: 100%; margin: 20px auto; border-radius: 10px;overflow: hidden;background-color: #efefef;">
        <div style="background: #503f8b; padding: 10px;color: white;font-weight: 600;">Your Recommended Plan</div>
        <div style="display: flex;flex-wrap: wrap;padding: 10px;">
            <div style="width: 100%;margin: 10px 0;">
                <div style="color: #503f8b;"><b>Stage 2 & 3:</b> <span style="border-bottom: 1px solid #503f8b;padding-bottom: 2px;">Basic Dr. Consultation</span></div>
            </div>
            <div style="width: 100%;margin: 10px 0;">
                <div style="color: #503f8b;"><b>Stage 4 & 5:</b> <span style="border-bottom: 1px solid #503f8b;padding-bottom: 2px;">Advance Dr. Consultation</span></div>
            </div>
        </div>
    </div>
    <div style="width: 100%; margin: 20px auto; border-radius: 10px;overflow: hidden;background-color: #efefef;">
        <div style="background: #503f8b; padding: 10px;color: white;font-weight: 600;">Important Notes</div>
        <div style="display: flex;flex-wrap: wrap;padding: 10px;">
            <div style="width: 100%;margin: 10px 0; display: flex;align-items: center;justify-content: left;gap: 10px;">
               <div style="width: 5px;height: 5px;background-color: #503f8b;border-radius: 40px;"></div>
               <div style="color: #503f8b;">Use only as adviced.</div>
            </div>
            <div style="width: 100%;margin: 10px 0; display: flex;align-items: center;justify-content: left;gap: 10px;">
               <div style="width: 5px;height: 5px;background-color: #503f8b;border-radius: 40px;"></div>
               <div style="color: #503f8b;">Do not exceed recommended dose.</div>
            </div>
            <div style="width: 100%;margin: 10px 0; display: flex;align-items: center;justify-content: left;gap: 10px;">
               <div style="width: 5px;height: 5px;background-color: #503f8b;border-radius: 40px;"></div>
               <div style="color: #503f8b;">If irritation or side effects occurs, discontinue and consult us.</div>
            </div>
        </div>
    </div> 
    <div style="width: 100%; margin: 20px auto; border-radius: 10px;overflow: hidden;background-color: #efefef;">
        <div style="background: #503f8b; padding: 10px;color: white;font-weight: 600;">Your Consulting Doctor</div>
        <div style="display: flex;justify-content: space-evenly;padding: 10px;color: #503f8b;">
          <div style="width: 30%;display: flex;align-items: center;justify-content: space-evenly;padding: 10px;background-color: #dcdcdc;border-radius: 10px;gap: 10px;">
             <div style="width: 100%; font-size: 12px">
                <p style="margin: 0;">
                  <strong>Dr. Piyush Tripathi </strong><br />
                   M.B.B.S and MS Senior Urologist, Surgeon Regency Health Care, Kanpur
                </p>
             </div>
          </div>
          <div style="width: 30%;display: flex;align-items: center;justify-content: space-evenly;padding: 10px;background-color: #dcdcdc;border-radius: 10px;gap: 10px;">
             <div style="width: 100%; font-size: 12px">
                <p style="margin: 0;">
                  <strong>Dr. Preeti Agarwal </strong><br />
                   M.B.B.S and MD Head Gynaecologist Arogya Hospital, Raipur
                </p>
             </div>
          </div>
          <div style="width: 30%;display: flex;align-items: center;justify-content: space-evenly;padding: 10px;background-color: #dcdcdc;border-radius: 10px;gap: 10px;">
             <div style="width: 100%; font-size: 12px">
                <p style="margin: 0;">
                  <strong>Dr. Anil Jain </strong><br />
                   M.B.B.S and MS Senior Urologist Amulya Jeevan Clinic, Kanpur
                </p>
             </div>
          </div>
        </div>
    </div>
    <div style="text-align: center;color: #503f8b;">Issued electronically by My Soul Clinic.</div>
</main>`;
            const iframe = document.createElement("iframe");
            iframe.style.position = "fixed";
            iframe.style.right = "0";
            iframe.style.bottom = "0";
            iframe.style.width = "0";
            iframe.style.height = "0";
            iframe.style.border = "0";
                      
            document.body.appendChild(iframe);
                      
            const iframeDoc = iframe.contentWindow.document;
            iframeDoc.open();
            iframeDoc.write(pdfhtmlcontent);
            iframeDoc.close();
                      
            iframe.onload = function () {
              setTimeout(() => {
                html2pdf()
                  .set({
                    filename: 'my-recommendation.pdf',
                    margin: 10,
                    image: { type: 'jpeg', quality: 0.98 },
                    html2canvas: {
                      scale: 2,
                      useCORS: true,
                      scrollX: 0,
                      scrollY: 0
                    },
                    jsPDF: {
                      unit: 'mm',
                      format: 'a4',
                      orientation: 'portrait'
                    }
                  })
                  .from(iframeDoc.body)
                  .save()
                  .then(() => {
                    document.body.removeChild(iframe);
                  });
              }, 500); // allow layout + images to fully render
            };
          }


          bundleBtn.addEventListener("click", (e) => {

             if (!popupSeen) {
              e.preventDefault();
              e.stopPropagation();
                document.querySelector(".quiz-popup-pdf--main").classList.add("active");
                document.querySelector("#an--pdf-downloadLinkSetter .button-downloadPDF").addEventListener("click", (e)=>{
                  generatePDF();
                  const loaderURL = "https://cdn.shopify.com/s/files/1/0870/7112/9886/files/instagram-stories_12198808.gif?v=1771502743";

                  const preloadedImg = new Image();
                  preloadedImg.src = loaderURL;
                  preloadedImg.width = 20;
                  e.currentTarget.innerHTML = '';
                  e.currentTarget.appendChild(preloadedImg.cloneNode());
                  e.currentTarget.append(" Generating...");
                  // e.currentTarget.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0870/7112/9886/files/instagram-stories_12198808.gif?v=1771502743" width="20px"/>`;
                  setTimeout(()=>{
                    document.querySelector("#an--pdf-downloadLinkSetter .button-downloadPDF").innerHTML = `Download Your PDF`;
                  }, 1000);
                })
                document.querySelector(".an--popup-close").addEventListener("click", () => {
                  document.querySelector(".quiz-popup-pdf--main").classList.remove("active");
                });
                document.querySelector("#an--ptc--initiatorButton").addEventListener("click", ()=>{
                  document.querySelector(".an--popup-close").click();
                  bundleBtn.click();
                })
                popupSeen = true;
              return; // STOP checkout logic
            }
            // Second click → run checkout normally
            popupSeen = false; // reset for next time

            (()=>{
              const dataset = JSON.parse(localStorage.getItem("JSON_DATA_SET_ASSEMENT"));
              const dateOfCreation = new Date(); 
              const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
              fetch(`${window.location.href.replace('/pages/take-quiz', '/cart/update.js')}`,{
                method: "POST",
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                  attributes : {
                      "Name" : dataset.name,
                      "Issue" : dataset.issue_title,
                      "Stage" : dataset.stage,
                      "Stage Title" : dataset.stageTitle,
                      "Products" : `${dataset.products.map((pd)=>`${pd.title}: (${pd.quantity} Quantity), `)}`,
                      "Assessment Date": `${months[dateOfCreation.getMonth()]} ${dateOfCreation.getDate()}, ${dateOfCreation.getFullYear()}`
                  }
                })
              })
              .then(response => response.json())
              .then(cart => {console.log("Cart attribute set:" + cart.attributes)});
            })();
            bundleBtn.classList.add("loading");
            // Build selectedVariants with index reference
            const selectedVariants = [];

            window.productData.forEach((prod, i) => {
              const selector = document.querySelector(`.variant_selector[data-index="${i}"]`);
              let variantId;
            
              if (selector) {
                variantId = selector.value;
              } else if (prod.variants && prod.variants.length) {
                variantId = prod.variants[0].id;
              }
            
              if (variantId) {
                selectedVariants.push({
                  productIndex: i,
                  id: Number(variantId),
                });
              }
            });

            // Then call:
            buyNowBundle(selectedVariants, bundleBtn);

          });
          bundleBox.appendChild(bundleBtn);

          productWrapper.appendChild(bundleHeader);
          productWrapper.appendChild(cardsRow);
          productWrapper.appendChild(subtotalBox);
          productWrapper.appendChild(bundleBox);

          // Desktop version
          productWrapper.classList.add("desktop_bundle_wrapper");
          resultBox.appendChild(productWrapper);

          // Mobile version
          const mobileBundleWindow = document.createElement("div");
          mobileBundleWindow.classList.add("mobile_bundle_window_wrpper");
          const productWrapperClone = productWrapper.cloneNode(true);
          mobileBundleWindow.appendChild(productWrapperClone);
          mobileBundleWindow.querySelector(".quiz_products_wrapper").classList.remove('desktop_bundle_wrapper');

          const collapsedBar = document.createElement("div");
          collapsedBar.classList.add("bundle_collapsed_bar");
          collapsedBar.innerHTML = `<span>View Bundle</span>`;
          mobileBundleWindow.appendChild(collapsedBar);

          const headerBtn = mobileBundleWindow.querySelector(".bundle_toggle_btn");
          const wrapper = mobileBundleWindow.querySelector(".quiz_products_wrapper");

          headerBtn.addEventListener("click", () => {
            wrapper.classList.add("hide_mobile_window");
            mobileBundleWindow.classList.add("is-collapsed");
          });

          collapsedBar.addEventListener("click", () => {
            wrapper.classList.remove("hide_mobile_window");
            mobileBundleWindow.classList.remove("is-collapsed");
          });

          resultBox.appendChild(mobileBundleWindow);

          // Variant selector change handler
          cardsRow.addEventListener("change", e => {
            if (!e.target.classList.contains("variant_selector")) return;
            const index = Number(e.target.dataset.index);
            const selectedOption = e.target.selectedOptions[0];
            window.productData[index].selectedPrice = Number(selectedOption.dataset.price);
            updateBundleSubtotal();
          });

          // Consultation remove handler
          cardsRow.addEventListener("click", e => {
            if (e.target.classList.contains("remove-consultation")) {
              e.preventDefault();
              e.stopPropagation();
            }
          });
        })
        .catch(err => {
          console.error("Error in Promise.all products:", err);
        });
    }
  }

  // === CONSULTATION PRODUCTS SECTION (ALWAYS RUNS) ===
  setTimeout(() => {
    const resultBoxContentWrap = resultBox.querySelector('.result_box_content_wrap');
    const consultationSection = resultBoxContentWrap?.querySelector('.consultation-products-section');
    
    console.log('Consultation setup - resultBoxContentWrap:', resultBoxContentWrap);
    console.log('Consultation section exists:', !!consultationSection);

    if (resultBoxContentWrap && consultationSection) {
      consultationSection.style.display = 'block';

      Promise.all(CONSULTATION_PRODUCTS.map(p => fetchConsultationProduct(p.handle)))
        .then(consultationProducts => {
          console.log('Consultation products fetched:', consultationProducts);
          const grid = consultationSection.querySelector('.consultation-grid');
          
          consultationProducts.forEach((product, index) => {
            if (product && product.featured_image) {
              const card = document.createElement('div');
              card.classList.add('consultation-card');
              card.innerHTML = `
                <div class="consultation-image">
                  <img src="${product.featured_image}" alt="${product.title}">
                </div>
                <div class="consultation-info">
                  <!-- <h5 style="margin: 12px 0 8px 0; font-size: 16px; font-weight: 600;">${product.title}</h5> -->
                  <p class="consultation_price">
                    ${typeof Shopify !== 'undefined' && Shopify.formatMoney ? 
                      Shopify.formatMoney(product.price) : 
                      `₹${(product.price / 100).toFixed(2)}`}
                  </p>
                  <button class="add-consultation-btn" data-handle="${product.handle}" data-index="${index}">
                    Add to Treatment Plan
                  </button>
                </div>
              `;
              grid.appendChild(card);
            }
          });

          // Bind add to cart buttons
          consultationSection.querySelectorAll('.add-consultation-btn').forEach(btn => {
            btn.addEventListener('click', async (e) => {
              const handle = e.target.dataset.handle;
              const consultationProduct = await fetchConsultationProduct(handle);
              
              if (consultationProduct && window.productData) {
                const mainCardsRow = resultBox.querySelector('.quiz_products');
                if (mainCardsRow) {
                  e.target.textContent = 'Added!';
                  e.target.style.background = '#28a745';
                  e.target.style.color = 'white';
                  e.target.disabled = true;
                  
                  setTimeout(() => {
                    e.target.textContent = 'Add to Treatment Plan';
                    e.target.style.background = '';
                    e.target.style.color = '';
                    e.target.disabled = false;
                  }, 2000);
                  
                  addConsultationToBundle(consultationProduct, window.productData, mainCardsRow);
                }
              }
            });
          });

          console.log('Consultation section fully loaded');
        })
        .catch(err => console.error('Error loading consultation products:', err));
    }
  }, 200);
}

function emailBodyFormatter(userData){
  let personalized_men_questions = [];
  let personalized_women_questions = [];
  if(userData.gender == "men"){
    for(keyn in userData.answers){
      men_quiz_data.forEach((que, index)=>{
        if(men_quiz_data[index].qid == keyn){
          personalized_men_questions.push(men_quiz_data[index].qtext);
        }
      })
    }
    console.log(personalized_men_questions);  
  } else {
    for(keyn in userData.answers){
      women_quiz_data.forEach((que, index)=>{
        if(women_quiz_data[index].qid == keyn){
          personalized_women_questions.push(women_quiz_data[index].qtext);
        }
      })
    }
    console.log(personalized_women_questions);
  }

  const answerKeyMen = `M${userData.issue_id.replace("M00","")}`;
  const answerKeyWomen = `W${userData.issue_id.replace("W00","")}`;

  const mail_content = `
  <b>CUSTOMER PROFILE -- </b><br><br>
  <span>NAME: ${userData.name}</span><br>
  <span>GENDER: ${userData.gender}</span><br>
  <span>PRIMARY CONCERN: ${userData.issue_title}</span><br>
  <br>
  <span>CONDITION ASSESSMENT -- </span><br>
  <span>
    ${(userData.gender == "men") ? personalized_men_questions[0].toUpperCase() : personalized_women_questions[0].toUpperCase()}: 
    ${(userData.gender == "men") ? userData.answers[`${answerKeyMen}Q1`] : userData.answers[`${answerKeyWomen}Q1`]}
  </span>
  <span>
    ${(userData.gender == "men") ? personalized_men_questions[1].toUpperCase() : personalized_women_questions[1].toUpperCase()}: 
    ${(userData.gender == "men") ? userData.answers[`${answerKeyMen}Q2`] : userData.answers[`${answerKeyWomen}Q2`]}
  </span>
  <span>
    ${(userData.gender == "men") ? personalized_men_questions[2].toUpperCase() : personalized_women_questions[2].toUpperCase()}: 
    ${(userData.gender == "men") ? userData.answers[`${answerKeyMen}Q3`] : userData.answers[`${answerKeyWomen}Q3`]}
  </span>
  <span>
    ${(userData.gender == "men") ? personalized_men_questions[3].toUpperCase() : personalized_women_questions[3].toUpperCase()}: 
    ${(userData.gender == "men") ? userData.answers[`${answerKeyMen}Q4`] : userData.answers[`${answerKeyWomen}Q4`]}
  </span>
  <span>
    ${(userData.gender == "men") ? personalized_men_questions[4].toUpperCase() : personalized_women_questions[4].toUpperCase()}:  
    ${(userData.gender == "men") ? userData.answers[`${answerKeyMen}Q5`] : userData.answers[`${answerKeyWomen}Q5`]}
  </span>
  <span>
    ${(userData.gender == "men") ? personalized_men_questions[5].toUpperCase() : personalized_women_questions[5].toUpperCase()}: 
    ${(userData.gender == "men") ? userData.answers[`${answerKeyMen}Q6`] : userData.answers[`${answerKeyWomen}Q6`]}
  </span>
  <span>
    ${(userData.gender == "men") ? personalized_men_questions[6].toUpperCase() : personalized_women_questions[6].toUpperCase()}: 
    ${(userData.gender == "men") ? userData.answers[`${answerKeyMen}Q7`] : userData.answers[`${answerKeyWomen}Q7`]}
  </span>
  <span>
    ${(userData.gender == "men") ? personalized_men_questions[7].toUpperCase() : personalized_women_questions[7].toUpperCase()}: 
    ${(userData.gender == "men") ? userData.answers[`${answerKeyMen}Q8`] : userData.answers[`${answerKeyWomen}Q8`]}
  </span><br><br>
  <span>CLINICAL EVALUATION -- </span>  <br>
  <span>CONDITION STAGE: ${userData.stage}</span><br>
  <span>ASSESSMENT SCORE: ${userData.totalScore}</span><br>
  <span>CLINICAL CATEGORY: ${userData.stageTitle}</span><br><br><br><br>
  <span>RECOMMENDED TREATMENT PLAN -- </span><br><br>
  ${userData.products.map((pd)=>`<span>${pd.title}: (${pd.quantity} Quantity)</span><br>`)}`;
  document.getElementById("contact_form_page-message").value = mail_content;
  document.getElementById("an--form-data-mail--initializer").addEventListener("click", (e)=>{
    e.preventDefault();
    console.log("Mail Sented!");
  })
  // document.getElementById("an--form-data-mail--initializer").click();
}

function initTestimonialSlider(root) {
  const slider = root.querySelector(".testimonial_slider");
  if (!slider) return;

  const track = slider.querySelector(".testimonial_track");
  const cards = track ? track.querySelectorAll(".testimonial_card") : [];
  if (!track || !cards.length) return;

  const prevBtn = root.querySelector(".testimonial_prev");
  const nextBtn = root.querySelector(".testimonial_next");

  let currentIndex = 0;
  let autoTimer = null;

  function updateSlider() {
    const offset = -currentIndex * 100;
    track.style.transform = `translateX(${offset}%)`;
  }

  function goTo(index) {
    const total = cards.length;
    currentIndex = (index + total) % total;
    updateSlider();
  }

  function next() {
    goTo(currentIndex + 1);
  }

  function prev() {
    goTo(currentIndex - 1);
  }

  // manual controls
  if (nextBtn) nextBtn.addEventListener("click", () => {
    next();
    restartAuto();
  });
  if (prevBtn) prevBtn.addEventListener("click", () => {
    prev();
    restartAuto();
  });

  // auto slide
  function startAuto() {
    autoTimer = setInterval(next, 5000);
  }

  function stopAuto() {
    if (autoTimer) clearInterval(autoTimer);
  }

  function restartAuto() {
    stopAuto();
    startAuto();
  }

  slider.addEventListener("mouseenter", stopAuto);
  slider.addEventListener("mouseleave", startAuto);

  updateSlider();
  startAuto();
}

function initFaqAccordion(root) {
  const accordion = root.querySelector(".faq_accordion");
  if (!accordion) return;

  const items = accordion.querySelectorAll(".faq_item");

  items.forEach(item => {
    const btn = item.querySelector(".faq_question_btn");
    const answer = item.querySelector(".faq_answer");
    if (!btn || !answer) return;

    btn.addEventListener("click", () => {
      const isActive = item.classList.contains("faq_item--active");

      // close others
      items.forEach(it => {
        const ans = it.querySelector(".faq_answer");
        const icon = it.querySelector(".faq_icon");
        if (!ans) return;
        it.classList.remove("faq_item--active");
        ans.style.maxHeight = "0";
        if (icon) icon.textContent = "+";
      });

      if (!isActive) {
        item.classList.add("faq_item--active");
        answer.style.maxHeight = answer.scrollHeight + "px";
        const icon = item.querySelector(".faq_icon");
        if (icon) icon.textContent = "−";
      }
    });
  });
}


function toggleRequired(item, enable) {
    item.querySelectorAll("input").forEach(input => {
      if (enable) {
        if (input.hasAttribute("data-required")) {
          input.setAttribute("required", "required");
        }
      } else {
        if (input.hasAttribute("required")) {
          input.setAttribute("data-required", "true");
        }
        input.removeAttribute("required");
      }
    });
  }

});

